"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveOrder = void 0;
var engine_types_1 = require("@verified/c11-engine.types");
var resolveOrder = function (graph) {
    var order = Object.keys(graph)
        .filter(function (x) {
        return graph[x].type === engine_types_1.GraphNodeType.INTERNAL;
    })
        .sort(function (a, b) {
        if (graph[a].isDependedBy.includes(b)) {
            return -1;
        }
        else {
            return 1;
        }
    });
    return order;
};
exports.resolveOrder = resolveOrder;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzb2x2ZU9yZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dyYXBoL3Jlc29sdmVPcmRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxrREFBa0U7QUFFM0QsSUFBTSxZQUFZLEdBQUcsVUFBQyxLQUFxQjtJQUNoRCxJQUFNLEtBQUssR0FBYSxNQUFNLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztTQUN2QyxNQUFNLENBQUMsVUFBQyxDQUFDO1FBQ1IsT0FBTyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxLQUFLLDRCQUFhLENBQUMsUUFBUSxDQUFDO0lBQ2xELENBQUMsQ0FBQztTQUNELElBQUksQ0FBQyxVQUFDLENBQUMsRUFBRSxDQUFDO1FBQ1QsSUFBSSxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUNyQyxPQUFPLENBQUMsQ0FBQyxDQUFDO1NBQ1g7YUFBTTtZQUNMLE9BQU8sQ0FBQyxDQUFDO1NBQ1Y7SUFDSCxDQUFDLENBQUMsQ0FBQztJQUVMLE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBZFcsUUFBQSxZQUFZLGdCQWN2QiJ9